import {
    COMMON_VALUES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    SWITCH_LANGUAGE,
    SET_MEMBERSHIP,
    SOCKET_MODAL,
    SEARCH_JUSTGIVING_CHARITY,
} from './commonTypes'

export default (state, action) => {
    switch (action.type) {
        case COMMON_VALUES:
            return {
                ...state,
                ...action.payload,
            }
        case SOCKET_MODAL:
            return {
                ...state,
                socketModal: !state.socketModal,
            }
        case SEARCH_JUSTGIVING_CHARITY:
            return {
                ...state,
                charityDetails: action.payload,
            }
        case SWITCH_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case SET_MEMBERSHIP:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}
